/**
 * @file collapse.
 * @author Selectra Front End Team
 * @version 1.0.0
 * @requires Polyfill:Element.prototype.classList
 * @requires Polyfill:Nodelist.prototype.forEach
 */

import delegate from '../00-utilities/delegate';

export default class Collapse {
  constructor() {
    delegate({
      target: '.collapse__header',
      listener: this.onClickCollapseHeader.bind( this ),
      event: 'click'
    })
    this.init()
  }

  init() {
    document.querySelectorAll( '.collapse' ).forEach(( collapse, index ) => {
      // Init aria
      this.initAria( collapse, index );
      // Open collapses
      if ( collapse.getAttribute( 'data-opened' ) === 'true' ) {
        this.open( collapse, false );
      }
    })
  }

  initAria( collapse, index ) {
    let collapseHeader = collapse.querySelector( '.collapse__header' ),
      collapseContent = collapse.querySelector( '.collapse__content' );

    // Set content id
    if ( !collapseContent.id ) {
      collapseContent.id = `collapse${index}`;
    }
    // Set header id
    if ( !collapseHeader.id ) {
      collapseHeader.id = `collapseheader${index}`;
    }
    // Set aria-controls
    collapseHeader.setAttribute( 'aria-controls', `collapse${index}` );
    // Set aria-expanded
    collapseHeader.setAttribute( 'aria-expanded', 'false' );
    // Set aria-labelledby
    collapseContent.setAttribute( 'aria-labelledby', `collapseheader${index}` );
  }

  onClickCollapseHeader( e ) {
    e.preventDefault();
    const collapse = e.target.parentElement;
    collapse.classList.contains( 'js-is--open' ) ? this.close( collapse ) : this.open( collapse );
  }

  open( collapse, transition = true ) {
    let collapseHeader = collapse.querySelector( '.collapse__header' ),
      collapseContent = collapse.querySelector( '.collapse__content' );

    if ( !collapseContent.dataset.maxHeight ) {
      this._computeMaxHeight( collapseContent, transition );
    }
    // Add Max height
    collapseContent.style.maxHeight = collapseContent.dataset.maxHeight + 'px';
    collapse.classList.add( 'js-is--open' );

    // Update aria
    collapseHeader.setAttribute( 'aria-expanded', 'true' );
  }

  close( collapse ) {
    let collapseHeader = collapse.querySelector( '.collapse__header' ),
      collapseContent = collapse.querySelector( '.collapse__content' );
    this._removeMaxHeight( collapseContent );
    collapse.classList.remove( 'js-is--open' );

    // Update aria
    collapseHeader.setAttribute( 'aria-expanded', 'false' );
  }

  _computeMaxHeight( collapseContent, transition = true ) {
    collapseContent.style.maxHeight = 'none';
    collapseContent.dataset.maxHeight = collapseContent.offsetHeight;
    collapseContent.style.maxHeight = '';

    if ( transition ) {
      //FORCE REPAINT (Make transition working after repaint)
      collapseContent.clientWidth;
    }

  }

  _removeMaxHeight( collapseContent ) {
    collapseContent.style.maxHeight = '';
  }
}
